import { render, staticRenderFns } from "./GermanSearch.vue?vue&type=template&id=7f40fd03&"
import script from "./GermanSearch.vue?vue&type=script&lang=js&"
export * from "./GermanSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports